/**
 * @license
 * Copyright 2026 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

import {CheckboxElement} from './checkbox-element.js';

declare global {
  interface HTMLElementTagNameMap {
    /** A Material Design component. */
    'md-gb-checkbox': CheckboxElement;
  }
}

customElements.define('md-gb-checkbox', CheckboxElement);
